module.exports = __webpack_public_path__ + "img/no-data_storage.a2ae307a.svg";